module.exports = __webpack_public_path__ + "static/media/marnie.4c1aea48.jpg";